import { getFormattedEquipmentTypes } from "../../requests/type-requests";

const headerCells = [
    {
        id: 'activity',
        label: 'Activity'
    },
    {
        id: 'activityDate',
        label: 'Date'
    },
    {
        id: 'containerNumber',
        label: 'Container'
    },
    {
        id: 'trailerNumber',
        label: 'Trailer'
    },
    {
        id: 'chassisNumber',
        label: 'Chassis'
    },
    {
        id: 'truckLicensePlateNumber',
        label: 'Truck License Plate Number'
    },
    {
        id: 'chassisLicensePlateNumber',
        label: 'Chassis License #'
    },
    {
        id: 'assetSize',
        label: 'Size'
    },
    {
        id: 'driverFirstName',
        label: 'First Name (Driver)'
    },
    {
        id: 'driverLastName',
        label: 'Last Name (Driver)'
    },
    {
        id: 'driverLicenseNumber',
        label: 'License (Driver)'
    },
    {
        id: 'sealNumber',
        label: 'Seal'
    },
    {
        id: 'assetType',
        label: 'Type'
    },
    {
        id: 'orderNumber',
        label: 'Booking'
    },
    {
        id: 'locationName',
        label: 'Location'
    },
    {
        id: 'supplierName',
        label: 'Supplier'
    },
    {
        id: 'currentInventory',
        label: 'Inventory'
    },
    {
        id: 'correctionStatus',
        label: 'Correction Status'
    }
];

const filterBySelectOption = (snackbarShowMessage) => [
    {
        label: "Equipment Type",
        value: "",
        name: "equipmentType",
        option: getFormattedEquipmentTypes(snackbarShowMessage)
    }
];

const sortByOptions: {label: string, value: string}[] = [
    {label: 'Activity', value: 'ACTIVITY'},
    {label: 'Activity Date', value: 'ACTIVITY_DATE'},
    {label: 'Container', value: 'CONTAINER_NUMBER'},
    {label: 'Trailer', value: 'TRAILER_NUMBER'},
    {label: 'Chassis', value: 'CHASSIS_NUMBER'},
    {label: 'Chassis License #', value: 'CHASSIS_LICENSE_PLATE_NUMBER'},
    {label: 'Size', value: 'ASSET_SIZE'},
    {label: 'First Name (Driver)', value: 'DRIVER_FIRST_NAME'},
    {label: 'Last Name (Driver)', value: 'DRIVER_LAST_NAME'},
    {label: 'License (Driver)', value: 'DRIVER_LICENSE_NUMBER'},
    {label: 'Seal', value: 'SEAL_NUMBER'},
    {label: 'Type', value: 'ASSET_TYPE'},
    {label: 'Booking', value: 'ORDER_NUMBER'},
    {label: 'Location', value: 'LOCATION_NAME'},
    {label: 'Partner', value: 'SUPPLIER_NAME'},
    {label: 'Inventory', value: 'CURRENT_INVENTORY'}
];
const propertiesToCheck = ['activity', 'activityDate', 'containerNumber', 'trailerNumber',  'chassisNumber', 'chassisLicensePlateNumber', 'assetSize', 'driverFirstName', 'driverLastName', 'driverLicenseNumber', 'sealNumber', 'assetType', 'orderNumber', 'locationName', 'supplierName', 'currentInventory'];

export {
    headerCells,
    filterBySelectOption,
    sortByOptions,
    propertiesToCheck
}